import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

import ClientReportsTab from "../../../../components/Events/Event/ClientReports";
import {
  createClientPortalClientReport,
  deleteClientPortalClientReport,
  getClientPortalClientReport,
  getClientPortalClientReports,
} from "../../../../network/apis/clientPortalClientReports";
import { ROUTE_PATHS } from "../../../../utils/RoutesPaths";

const clientPortalClientReportsApi = {
  getList: getClientPortalClientReports,
  create: createClientPortalClientReport,
  getFile: getClientPortalClientReport,
  remove: deleteClientPortalClientReport,
};

const ClientEventClientReportsTab = ({ event }) => {
  const history = useHistory();

  const handleForbidden = useCallback(() => {
    history.replace(ROUTE_PATHS.clientPortalEvents);
  }, [history]);

  return (
    <ClientReportsTab
      event={event}
      api={clientPortalClientReportsApi}
      onForbidden={handleForbidden}
    />
  );
};

ClientEventClientReportsTab.propTypes = {
  event: PropTypes.object,
};

ClientEventClientReportsTab.defaultProps = {
  event: null,
};

export default ClientEventClientReportsTab;
